<template>
  <div class="rd-page">
    <redesign-header :minimal="minimal" />
    <main class="rd-main">
      <div :class="['rd-shell', containerClass]">
        <slot></slot>
      </div>
    </main>
    <footer class="rd-footer">
      <div class="rd-shell rd-footer-inner">
        <span>Waajo — platform WhatsApp untuk bisnis.</span>
        <span>
          <router-link to="/terms" class="rd-link">Ketentuan Layanan</router-link>
        </span>
      </div>
    </footer>
  </div>
</template>

<script>
import RedesignHeader from "./RedesignHeader.vue";

export default {
  name: "redesign-layout",
  components: {
    RedesignHeader
  },
  props: {
    minimal: {
      type: Boolean,
      default: false
    },
    containerClass: {
      type: String,
      default: ""
    }
  }
};
</script>

<style src="../theme.css"></style>



// WEBPACK FOOTER //
// src/views/redesign/components/RedesignLayout.vue